"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const getLibraryVersion_1 = require("../getLibraryVersion");
function getBaseEvent(command) {
    return {
        commandId: command.id,
        creatorId: command.creatorId,
        id: uuid_1.v4(),
        timeStamp: command.timeStamp,
        libraryVersion: getLibraryVersion_1.getLibraryVersion(),
        versionNumber: 1
    };
}
exports.getBaseEvent = getBaseEvent;
//# sourceMappingURL=getBaseEvent.js.map